import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

const routes = [
  { path: '/', redirect: '/dashboard' },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true, title: '登录' }
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '仪表盘' }
      },
      {
        path: 'crm',
        name: 'CRM',
        component: () => import('@/views/CRM.vue'),
        meta: { title: 'CRM' }
      },
      {
        path: 'analytics',
        name: 'Analytics',
        component: () => import('@/views/Analytics.vue'),
        meta: { title: 'Analytics' }
      },
      {
        path: 'workflows',
        name: 'Workflows',
        component: () => import('@/views/WorkflowList.vue'),
        meta: { title: '流程管理' }
      },
      {
        path: 'audits',
        name: 'Audits',
        component: () => import('@/views/AuditLog.vue'),
        meta: { title: '审计日志' }
      },
      {
        path: 'backups',
        name: 'Backups',
        component: () => import('@/views/BackupRestore.vue'),
        meta: { title: '备份/恢复' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/Users.vue'),
        meta: { title: '用户权限' }
      },
      {
        path: 'settlement/upload',
        name: 'SettlementUpload',
        component: () => import('@/views/SettlementUpload.vue'),
        meta: { title: '账单上传' }
      },
      {
        path: 'settlement/review/:id',
        name: 'SettlementReview',
        component: () => import('@/views/SettlementReview.vue'),
        meta: { title: '预览确认' }
      },
      {
        path: 'settlement/result/:id',
        name: 'SettlementResult',
        component: () => import('@/views/SettlementResult.vue'),
        meta: { title: '处理结果' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    return next()
  }
  const token = localStorage.getItem('access_token')
  if (!token) {
    return next('/login')
  }
  next()
})

export default router
